<template>
  <div class="setting">
    <v-container>
      <h2 class="mb-2">エンドユーザの削除(未実装)</h2>
      <div class="test">
        <p>Customerの設定</p>
      </div>
      <v-col align="right"><v-btn @click.once="back">戻る</v-btn></v-col>
      <!--
      <v-form ref="form" v-model="valid">
        <h3 class="mb-2">Customer名</h3>
        <v-row justify="space-around">
          <v-col align="right" cols="8">
            <v-text-field
              v-model="json.customer"
              placeholder="customer名を入力してください"
              :rules="[rules.required, rules.alphanumeric]"
              outlined
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-btn @click="pulus">＋</v-btn>
          </v-col>
          <v-col>
            <v-btn @click="minus">-</v-btn>
          </v-col>
        </v-row>
        <h3 class="mb-2">各ユーザ名・メールアドレス(最大20)</h3>
        <p>初期パスワードは P@assw0rd!</p>
        <div v-for="(emp, i) in json.employees" :key="i">
          <v-row>
            <v-col cols="1">
              <v-text-field :value="i + 1" disabled filled></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="json.employees[i].name"
                outlined
                label="ユーザ名"
                type="text"
                :rules="[rules.required, rules.alphanumeric]"
              >
              </v-text-field>
            </v-col>
            <v-col cols="7">
              <v-text-field
                v-model="json.employees[i].mail"
                outlined
                label="メールアドレス"
                type="text"
                :rules="[rules.required, rules.mail]"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </div>
      </v-form>
      -->
      <v-row justify="center" class="mt-4">
        <v-btn @click="modalOpen" color="primary">employeeの削除</v-btn>
      </v-row>
      <v-dialog v-if="check_dialog" v-model="check_dialog" max-width="350">
        <check-dialog
          v-on:clickSubmit="modalClose"
          :message="'employeeを削除しますか?'"
        />
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import checkDialog from "../../components/CheckDialog/CheckDialog";
import { RepositoryFactory } from "../../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");

export default {
  name: "Index",
  components: {
    checkDialog,
  },
  data: () => ({
    drawer: true,
    valid: true,
    json: {
      customer: "",
      employees: [{ mail: "", name: "" }],
    },
    check_dialog: false,
    rules: {
      required: (value) => !!value || "必須項目です",
      alphanumeric: (value) => {
        return /^[a-zA-Z0-9_]*$/.test(value) || "英数字のみ入力可能です。";
      },
      mail: (value) => {
        return (
          /^[a-zA-Z0-9.]{1}[A-Za-z0-9_.-]*@{1}[a-zA-Z0-9_.-]{1,}\.[a-zA-Z0-9]{1,}$/.test(
            value
          ) || "メールアドレスの形式が不正です"
        );
      },
      numonly: (value) => {
        return /^[0-9]*$/.test(value) || "数値のみ入力可能です。";
      },
    },
  }),
  methods: {
    pulus() {
      if (this.json.employees.length < 20) {
        this.json.employees.push({ mail: "", name: "" });
      }
    },
    minus() {
      if (this.json.employees.length > 1) {
        this.json.employees.pop();
      }
    },
    modalOpen() {
      if (this.json.customer != "") {
        this.check_dialog = true;
      }
    },
    modalClose(value) {
      this.check_dialog = false;
      if (value) {
        this.customerGenerate();
      }
    },
    async customerGenerate() {
      if (this.$refs.form.validate()) {
        const respose = await api.employeesGenerate(this.json);
        if (respose.result == "Sucsess") {
          alert("生成完了");
        } else {
          //alert("エラー");
          //console.log(respose.result);
        }
        console.log(respose);
      }
    },
    back() {
      history.back();
    },
  },
};
</script>
